import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../../../components/IconButton';
import { ChatInput } from '../../ChatInput';
import { SpecialistPickerProps } from '../../SpecialistPicker';
import { useCopyToClipboard } from '../useCopyToClipboard';
import { Bubble, PromptActions, PromptContainer } from './styles';

export interface UserPromptProps {
  content: string;
  canEdit: boolean;
  specialistPicker: SpecialistPickerProps;
  onEdit: (content: string) => void;
}

export const UserPrompt: FC<UserPromptProps> = ({
  content,
  canEdit,
  specialistPicker,
  onEdit
}) => {
  const { t } = useTranslation('activities');
  const { copied, copy } = useCopyToClipboard();
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(content);

  if (isEditing) {
    const submit = () => {
      const value = draft.trim();
      if (!value) return;
      setIsEditing(false);
      onEdit(value);
    };

    return (
      <PromptContainer>
        <ChatInput
          compact
          autoFocus
          value={draft}
          onChange={setDraft}
          onSubmit={submit}
          onCancel={() => setIsEditing(false)}
          specialistPicker={specialistPicker}
        />
      </PromptContainer>
    );
  }

  return (
    <PromptContainer>
      <Bubble>{content}</Bubble>
      <PromptActions>
        {canEdit && (
          <IconButton
            icon="edit"
            label={t('aiChat.editPrompt')}
            onClick={() => {
              setDraft(content);
              setIsEditing(true);
            }}
          />
        )}
        <IconButton
          icon="copy"
          label={copied ? t('aiChat.copied') : t('aiChat.copy')}
          onClick={() => copy(content)}
        />
      </PromptActions>
    </PromptContainer>
  );
};
